import React from 'react';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * "View only" pill. Usually via PageHeader viewOnly.
 *
 * @param {object} p
 * @param {string} [p.title]
 */
export function ViewOnlyPill({ title = 'You can view this page but not change it' }) {
  return h('span', { title, style: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 11px', border: ink(1.5), borderRadius: 20, background: 'var(--neu-bg)', fontFamily: BODY, fontSize: 11.5, fontWeight: 700, color: 'var(--tx2)' } }, 'View only');
}
